export enum DocumentType {
  NotaFiscaOuDeclaracaoDePropriedade = 1,
  FotoDoNumeroDeSerie = 2,
  FotoDaVisaoGeralDoEquipamento = 3,
  FotoGrupoCatracas = 4,
  FotoDasRodas = 5,
  FotoDoAcessorio = 6,
  Outros = 7,
  CPF = 8,
  CNPJ = 9,
  RG = 10,
  BoletimDeOcorrencia = 11,
  OrcamentoDeReparo = 12,
  FotoDaVisaoGeralDoEquipamentoDianteiraLadoDireito = 13,
  FotoDaVisaoGeralDoEquipamentoDianteiraLadoEsquerdo = 14,
  FotoRodaDianteira = 15,
  FotoRodaTraseira = 16,
  FotoFrontal = 17,
  FotoCambioDianteiro = 18,
  FotoCambioTraseiro = 19
}
